import { noop, compact } from 'lodash-es'
import { useSnackbarsStore } from 'settle-ui/hooks/useSnackbarsStore/useSnackbarsStore'
import type { Snackbar as SuiSnackbar } from 'settle-ui/hooks/useSnackbarsStore/useSnackbarsStore.types'
import { Snackbar } from '../Snackbar/Snackbar'
import { useRetained } from './hooks/useRetained/useRetained'
import * as $ from './Snackbars.styled'

interface SnackbarsProps {
  onMount?(snackbar: SuiSnackbar): void
  onUnmount?(snackbar: SuiSnackbar): void
  onMouseEnter?(snackbar: SuiSnackbar): void
  onMouseLeave?(snackbar: SuiSnackbar): void
  onActionClick?(snackbar: SuiSnackbar): void
  onCloseClick?(snackbar: SuiSnackbar): void
}

export const Snackbars: React.FC<SnackbarsProps> = ({
  onMount,
  onUnmount,
  onMouseEnter,
  onMouseLeave,
  onActionClick,
  onCloseClick,
}) => {
  const [retained, setRetained] = useRetained()

  const snackbars = useSnackbarsStore((store) => store.snackbars)
  const hideSnackbar = useSnackbarsStore((store) => store.hideSnackbar)

  return (
    <$.Root onMouseEnter={() => setRetained(true)} onMouseLeave={() => setRetained(false)}>
      {snackbars.map((snackbar) => (
        <Snackbar
          key={snackbar.id}
          id={snackbar.id}
          message={snackbar.message}
          variant={snackbar.variant}
          timeout={snackbar.options?.timeout}
          spinner={snackbar.options?.spinner}
          closable={snackbar.options?.closable}
          data-testid={snackbar.options?.['data-testid']}
          permanent={snackbar.options?.permanent}
          retained={retained}
          onMount={() => {
            onMount?.(snackbar)
          }}
          onMouseEnter={() => {
            onMouseEnter?.(snackbar)
          }}
          onMouseLeave={() => {
            onMouseLeave?.(snackbar)
          }}
          onCloseClick={() => {
            onCloseClick?.(snackbar)
          }}
          onClose={() => {
            onUnmount?.(snackbar)
            hideSnackbar(snackbar.id)
            snackbar.options?.onClose?.()
          }}
          buttons={compact(
            snackbar.options?.text
              ? [{ text: snackbar.options.text, onClick: snackbar.options.onClick ?? noop }]
              : snackbar.options?.buttons,
          ).map((button) => ({
            ...button,
            onClick: () => {
              onActionClick?.(snackbar)
              button.onClick?.()
              hideSnackbar(snackbar.id)
            },
          }))}
        />
      ))}
    </$.Root>
  )
}
